import { Layout } from "antd";
import { CodeForm } from "features/auth";
import { AuthHeader } from "widgets/headers";

export const CodePage = () => {
  return (
    <Layout>
      <AuthHeader />
      <Layout.Content
        style={{
          paddingTop: "13vh",
        }}
        className="auth-layout-content"
      >
        <CodeForm />
      </Layout.Content>
    </Layout>
  );
};
